/**
 * Split pasted or typed keyword text into unique trimmed tokens.
 * Delimiters: tab, newline, carriage return, comma (matches drawer Keywords paste).
 */
export function splitKeywordTokens(text) {
  if (!text || !/[^\s]/.test(text)) return [];

  const seen = new Set();
  return text
    .split(/[\t\n\r,]+/)
    .map((s) => s.trim())
    .filter((s) => {
      if (!s || seen.has(s)) return false;
      seen.add(s);
      return true;
    });
}
